<script lang="ts">
	export let thin = false;
	export let storke = "#bcbfc3";
	export let fill = "#bcbfc3";

</script>

{#if thin}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		viewBox="0 0 20.5 20.499">
		<g>
			<g>
				<path
					d="M203.836 430.06a.363.363 0 0 1-.254.1.353.353 0 0 1-.361-.346l-.028-19.306a.36.36 0 0 1 .72 0l.028 19.307a.333.333 0 0 1-.105.245z"
					transform="translate(-193.317 -409.912)"
					style={`fill:${fill};stroke:${storke};stroke-width:.5px`} />
			</g>
			<g>
				<path
					d="M210.192 423.675a.339.339 0 0 1-.245.106l-19.306.028a.361.361 0 0 1 0-.721l19.306-.028a.354.354 0 0 1 .348.36.368.368 0 0 1-.103.255z"
					transform="translate(-190.044 -413.185)"
					style={`fill:${fill};stroke:${storke};stroke-width:.5px`} />
			</g>
		</g>
	</svg>
{:else}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		viewBox="0 0 53.794 53.792">
		<g>
			<path
				d="M204.857 463.68a.932.932 0 0 1-1.592-.657l-.072-51.926a.933.933 0 1 1 1.865 0l.072 51.928a.913.913 0 0 1-.273.655z"
				transform="translate(-177.265 -410.162)"
				fill={fill} />
		</g>
		<g>
			<path
				d="M243.814 424.654a.93.93 0 0 1-.659.273l-51.926.073a.934.934 0 0 1 0-1.867l51.926-.072a.934.934 0 0 1 .661 1.594z"
				transform="translate(-190.294 -397.134)"
				fill={fill} />
		</g>
	</svg>
{/if}

<style lang="scss">
</style>
